import { render } from "./DropList.vue?vue&type=template&id=1727621f"
import script from "./DropList.vue?vue&type=script&lang=js"
export * from "./DropList.vue?vue&type=script&lang=js"

import "./DropList.vue?vue&type=style&index=0&id=1727621f&lang=sass"

import exportComponent from "D:\\Open Server 5.3.5\\OSPanel\\domains\\front\\personal_form\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__